"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encode = function (s) {
    if (typeof btoa !== 'undefined') {
        return btoa(s);
    }
    else if (typeof Buffer !== 'undefined') {
        return Buffer.from(s).toString('base64');
    }
    return s;
};
exports.decode = function (s) {
    if (typeof atob !== 'undefined') {
        return atob(s);
    }
    else if (typeof Buffer !== 'undefined') {
        return Buffer.from(s, 'base64').toString('utf8');
    }
    return s;
};
//# sourceMappingURL=base64.js.map